/**
 * @fileoverview Hook and component for handling automatic app updates and reloads.
 */

import {useEffect} from "react";

import {useAppVersionQuery} from "./useAppVersionQuery";

/**
 * Custom hook that monitors for app updates and triggers a page reload when available.
 * Uses the app version query to check for update availability.
 */
const useAppUpdateReload = () => {
  const {data} = useAppVersionQuery();

  const {updateAvailable = false} = data;

  useEffect(() => {
    if (updateAvailable) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      window.location.reload(true);
    }
  }, [updateAvailable]);
};

/**
 * Component that uses the app update reload hook.
 * Renders nothing but triggers the update check and reload logic.
 *
 * @returns {JSX.Element} A null element that performs the update check.
 */
export const AppUpdateReload = (): JSX.Element => {
  useAppUpdateReload();

  return null;
};
